import axios from "axios";
import qs from "qs";
import { api } from "@/plugins/util";

/**
 * 用户名密码登录方式
 * @param userName
 * @param password
 */
export function accountLogin({ userName, password ,code}) {
    return axios.post(
        api + "/login/user_name",
        qs.stringify({
            userName,
            password,code
        })
    );
}
/**
 * 用户名密码登录方式
 * @param userName
 * @param password
 */
export function accountLogin2({ userName, password , code}) {
    return axios.post(
        api + "/login/user_name2",
        qs.stringify({
            userName,
            password ,code
        })
    );
}
/**
 * 判断用户是否登录
 */
export function userStatus() {
    return axios.get(api + "/current_account");
}

/**
 * 用户退出
 */
export function loginOut() {
    return axios.get(api + "/logout");
}
export function hnzw() {
    return axios.get("https://auth.zwfw.hunan.gov.cn/oauth2/logout?client_id=cp4zF99JSqG8YDD1wKjB4A&response_type=code&redirect_uri=");
}
/**
 * 用户名密码登录方式
 * @param userName
 * @param password
 */
export function sendcode( userName ) {
    return axios.post(
        api + "/login/sendcode",
        qs.stringify({
            userName
        })
    );
}
export function sendcode2( userName,userType ) {
    return axios.post(
        api + "/login/sendcode2",
        qs.stringify({
            userName,userType
        })
    );
}
//批量发送信息
export function sendMsg( content ) {
    return axios.post(
        api + "/sendMsg/send",
        qs.stringify({
            content
        })
    );
}
